import { ProfileName } from 'components';
import { useCheckboxes } from 'hooks';
import React, { FC } from 'react';
import { UseFormMethods } from 'react-hook-form';
import { Profile } from 'types';
import { getProfileName } from 'utils/common';

import {
  StyledHeader,
  StyledHeaderLabel,
  StyledListItem,
  StyledListWrapper,
  StyledSelectAllButton,
} from './styled';

interface CheckListProps extends Partial<Pick<UseFormMethods, 'register'>> {
  items: Profile[];
  label: string;
  usersList?: boolean;
  withEmail?: boolean;
  preSelectAll?: boolean;
}

const CheckList: FC<CheckListProps> = ({
  items,
  label,
  usersList,
  withEmail,
  register,
  preSelectAll,
}) => {
  const { createCheckbox, selectAll, allChecked } = useCheckboxes(
    items,
    register,
    preSelectAll,
  );

  const renderUsers = (users: Profile[]) =>
    users.map((user) => (
      <StyledListItem key={user.id} htmlFor={user.id}>
        <div className="checkbox-wrapper">{createCheckbox(user.id)}</div>
        <div className="item-content">
          <div className="profile-wrapper">
            <ProfileName
              name={getProfileName(user)}
              avatar={user.smallLogo || user.logo}
            />
          </div>
          {withEmail && <div className="email-wrapper">{user.email}</div>}
        </div>
      </StyledListItem>
    ));

  const renderTitles = (titles) =>
    titles.map((title) => (
      <StyledListItem key={title.id} htmlFor={title.id}>
        <div className="checkbox-wrapper">{createCheckbox(title.id)}</div>
        <div className="title-wrapper">
          {title.title ? title.title : title.name}
        </div>
      </StyledListItem>
    ));

  return (
    <div>
      <StyledHeader>
        <StyledSelectAllButton
          type="button"
          onClick={selectAll}
          checked={allChecked}
        />
        <StyledHeaderLabel>{label}</StyledHeaderLabel>
      </StyledHeader>
      <StyledListWrapper>
        {usersList ? renderUsers(items) : renderTitles(items)}
      </StyledListWrapper>
    </div>
  );
};

export default CheckList;
